import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class NotAllowedTagError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.numberings.validation.format.not-allowed-tag-error');
    }
}
